import React from "react";
import { Button, Group, Paper, Text, Title } from "@mantine/core";
import { Download, FileSpreadsheet, FileText } from "lucide-react";

export const TOOLTIP_STYLE = {
  backgroundColor: "#18181b",
  border: "1px solid #27272a",
  borderRadius: "8px",
  color: "#fff",
};

const CHART_AXIS = { stroke: "#71717a", tick: { fill: "#71717a", fontSize: 11 } };
const CHART_GRID = { strokeDasharray: "3 3", stroke: "#27272a" };

export const chartProps = { axis: CHART_AXIS, grid: CHART_GRID };

export const KPICard = ({ title, value, suffix, prefix, change }) => (
  <Paper className="exec-kpi-card" p="md" radius="md">
    <Text size="xs" c="dimmed" mb={4} tt="uppercase" fw={600}>
      {title}
    </Text>
    <Text size="xl" fw={700} c="white" mb={change !== undefined ? 4 : 0}>
      {prefix ?? ""}
      {typeof value === "number" ? value.toLocaleString() : value}
      {suffix ?? ""}
    </Text>
    {change !== undefined && (
      <Text size="xs" c={change >= 0 ? "green.4" : "red.4"}>
        {change >= 0 ? "↑" : "↓"} {Math.abs(change)}% vs last period
      </Text>
    )}
  </Paper>
);

export const StatCard = ({ title, value, suffix, prefix }) => (
  <Paper className="exec-stat-card" p="md" radius="md">
    <Text size="xs" c="dimmed" mb={4} tt="uppercase" fw={600}>
      {title}
    </Text>
    <Text size="lg" fw={700} c="white">
      {prefix ?? ""}
      {typeof value === "number" ? value.toLocaleString() : value}
      {suffix ?? ""}
    </Text>
  </Paper>
);

export const ChartCard = ({ title, children }) => (
  <Paper className="exec-chart-card" p="lg" radius="md">
    <Text size="sm" fw={600} c="dimmed" mb="md" tt="uppercase">
      {title}
    </Text>
    {children}
  </Paper>
);

export const AnalyticsPageLayout = ({
  icon: Icon,
  title,
  subtitle,
  onExport,
  children,
}) => (
  <div className="exec-dashboard">
    <div className="exec-header">
      <div>
        <div className="flex items-center gap-2 text-zinc-500 mb-1">
          {Icon && <Icon size={18} />}
          <span className="text-sm">Analytics</span>
        </div>
        <Title order={2} className="text-white font-bold">
          {title}
        </Title>
        <Text size="sm" c="dimmed" mt={4}>
          {subtitle}
        </Text>
      </div>
      <Group gap="xs">
        <Button variant="light" size="xs" leftSection={<FileSpreadsheet size={14} />} onClick={() => onExport("excel")}>
          Excel
        </Button>
        <Button variant="light" size="xs" leftSection={<FileText size={14} />} onClick={() => onExport("pdf")}>
          PDF
        </Button>
        <Button variant="light" size="xs" leftSection={<Download size={14} />} onClick={() => onExport("csv")}>
          CSV
        </Button>
      </Group>
    </div>
    {children}
  </div>
);
